var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGirlseat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48641 9.81323C2.23715 9.47599 2.16384 9.04345 2.28114 8.64023L3.76205 3.73564C4.59781 0.964435 7.52296 -0.61178 10.2942 0.22398C11.9804 0.729835 13.3 2.04946 13.8058 3.73564L15.2867 8.64023C15.4993 9.34403 15.1035 10.0845 14.3997 10.2898C14.275 10.3264 14.1504 10.3484 14.0184 10.3484H3.54944C3.13156 10.3484 2.73567 10.1505 2.48641 9.81323Z",
    fill: "#D906BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5656 21.5992C17.5656 22.3323 16.9718 22.9262 16.246 22.9262H1.32695C0.59383 22.9262 0 22.3323 0 21.5992C0 16.7459 3.92954 12.8164 8.78281 12.8164C13.6361 12.8164 17.5656 16.7459 17.5656 21.5992Z",
    fill: "#D906BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlseat);
export default __webpack_public_path__ + "static/media/girlseat.4110fadd171033796f1b2408ce9051fb.svg";
export { ForwardRef as ReactComponent };